import { HttpClient } from "@angular/common/http";
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
var AgbService = /** @class */ (function () {
    function AgbService(_httpClient) {
        this._httpClient = _httpClient;
    }
    AgbService.prototype.loadAgbText = function () {
        return this._httpClient.get("api/agb").toPromise();
    };
    AgbService.ngInjectableDef = i0.defineInjectable({ factory: function AgbService_Factory() { return new AgbService(i0.inject(i1.HttpClient)); }, token: AgbService, providedIn: "root" });
    return AgbService;
}());
export { AgbService };
